<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm4 offset-sm4 pt-5>

        <v-alert  :value="true"  v-if="error != null" type="error" >{{ error.message }}</v-alert>
        <v-alert  :value="true"  v-if="success != null" type="success" >{{ success.message }}</v-alert>

        <v-layout justify-center column>
          <v-form ref="form" v-model="valid" lazy-validation @submit="changePassword">
            
            <v-layout row>
              <v-flex xs12 pt-0 pb-4>
                <p class="notice">Please enter your existing password and the new password that you wish to use in future. Once you click 'Update Password' the new password will be used for all future logins.</p>
                <p class="notice">Remember, a valid password must contain one upper case letter, one lower case letter, a number and a special character (e.g. ^ $ * . ! @ # % &) and also must be at least 8 characters in length.</p>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12>
                <v-text-field outline v-model="oldPassword" :rules="passRules" label="Current Password" type="password" required ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12>
                <v-text-field outline v-model="newPassword" :rules="newPassRules" label="New Password" type="password"  required ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12>
                <v-text-field outline v-model="newPasswordConfirm" :rules="passConfirmRules" label="Confirm New Password" type="password"  required ></v-text-field>
              </v-flex>
            </v-layout>

            

            <v-layout row align-center mx-1>
              <v-spacer />
              <button type="submit" class="button" :disabled="!valid">Update Password</button>
            </v-layout>

          </v-form>
        </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'UserProfile',
  data () {
    
    return {
      valid: true,
      passRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be at least 8 characters',
        v => /.*[a-z].*/.test(v) || 'Password must contain at least one lower case letter',
        v => /.*[A-Z].*/.test(v) || 'Password must contain at least one upper case letter',
        v => /\d/.test(v) || 'Password must contain at least one number',
        v => /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(v) || 'Password must contain at least one special character (e.g. ^ $ * . ! @ # % &)',
      ],
      newPassRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be at least 8 characters',
        v => /.*[a-z].*/.test(v) || 'Password must contain at least one lower case letter',
        v => /.*[A-Z].*/.test(v) || 'Password must contain at least one upper case letter',
        v => /\d/.test(v) || 'Password must contain at least one number',
        v => /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(v) || 'Password must contain at least one special character (e.g. ^ $ * . ! @ # % &)',
        v => (this.oldPassword.length >=8 && v != this.oldPassword) || 'Yor new password must not match your current password',
        v => (this.newPasswordConfirm.length >=8 && v == this.newPasswordConfirm) || 'New Password must match your new password confirmation'
      ],
      passConfirmRules: [
        v => (v == this.newPassword) || 'New password confirmation must match your new password'
      ],
      oldPassword: '',
      newPassword: '',
      newPasswordConfirm: '',
      error: null,
      success: null,
      loading: false
    }
  },
  created () {
  },
  watch: {
    newPasswordConfirm: function (val, oldVal) {
      this.$refs.form.validate()
    },
    newPassword: function (val, oldVal) {
      this.$refs.form.validate()
    }
  },
  methods: {
    changePassword (e) {
        e.preventDefault()
        this.loading = true
        
        this.$changePassword(this.oldPassword, this.newPassword).subscribe((response) => {
            this.success = response
            this.error = null
            this.$signOut();
            this.$router.push("/");
        }, 
        (err)=> {
            //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
            console.log(err);
            this.success = null
            this.error = err
        });    
    }
  }
}
</script>

<style scoped>
</style>